import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListBrandsComponent } from './components/list-brands/list-brands.component';
import { AddBrandsComponent } from './components/add-brands/add-brands.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UiModule } from 'src/app/ui/ui.module';



@NgModule({
  declarations: [
    ListBrandsComponent,
    AddBrandsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
  ]
})
export class BrandsModule { }
